import { createContext, useContext, useMemo, useState } from 'react'

// facebookPixel renders as a sibling of the page content under Layout, so the
// signup result cannot live in the form's own state.
export const ShowingSignupResultContext = createContext()

export const useShowingSignupResult = () =>
  useContext(ShowingSignupResultContext)

export const ShowingSignupResultProvider = ({ children }) => {
  const [result, setResult] = useState()

  const value = useMemo(() => ({ result, setResult }), [result])

  return (
    <ShowingSignupResultContext.Provider value={value}>
      {children}
    </ShowingSignupResultContext.Provider>
  )
}
